import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

const RAINBOW = "linear-gradient(90deg,#e11d48,#f97316,#facc15,#22c55e,#3b82f6,#8b5cf6)";

/**
 * The community guide, set as the page's one full-colour moment: an ink card
 * with a wide didone headline, a rainbow hairline and a single way in.
 */
export default function PrideFeature() {
  const { lang } = useLang();
  const es = lang === "es";

  return (
    <Link
      to="/?section=lgbtq"
      className="group relative block overflow-hidden rounded-[22px] bg-[#0d0a11] text-white shadow-[0_20px_50px_-24px_rgba(29,18,32,0.55)] transition-transform duration-500 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#f472b6] focus-visible:ring-offset-2 sm:rounded-[28px]"
    >
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 88% 8%, rgba(217,70,239,0.45), transparent 42%), radial-gradient(ellipse at 74% 108%, rgba(236,72,153,0.34), transparent 44%), radial-gradient(ellipse at 4% 96%, rgba(56,189,248,0.20), transparent 46%)",
        }}
      />
      <span aria-hidden="true" className="absolute inset-x-0 top-0 h-[3px]" style={{ background: RAINBOW }} />
      <span
        aria-hidden="true"
        className="yts-edit-title pointer-events-none absolute -right-2 -bottom-6 select-none text-[26vw] leading-none text-white/[0.055] sm:-right-4 sm:text-[190px]"
      >
        365
      </span>

      <div className="relative px-5 py-7 sm:px-10 sm:py-11">
        <div className="flex items-center gap-2.5">
          <span aria-hidden="true" className="h-[2px] w-8 rounded-full" style={{ background: RAINBOW }} />
          <span className="yts-edit-kicker text-[8.5px] tracking-[0.26em] text-[#f9b8dd]">
            {es ? "Comunidad · Todo el año" : "Community · Pride year-round"}
          </span>
        </div>

        <h2 className="yts-edit-title mt-3 max-w-[18ch] text-[clamp(30px,7.4vw,62px)] text-white">
          {es ? "Puerto Rico LGBTQ+" : "Puerto Rico LGBTQ+"}
          <span className="text-[#f472b6]">.</span>
        </h2>

        <p className="yts-edit-deck mt-3 max-w-[42ch] text-[13px] leading-[1.6] text-white/70 sm:text-[15px]">
          {es
            ? "Espacios, noches, negocios y comunidad en toda la isla — curada por quienes viven aquí."
            : "Spaces, nights, businesses and community across the island — curated by the people who live here."}
        </p>

        <span className="mt-6 inline-flex min-h-11 items-center gap-2 rounded-full bg-white px-5 text-[10px] font-black uppercase tracking-[0.14em] text-[#0d0a11] transition-colors group-hover:bg-[#ffe8f4]">
          {es ? "Explorar la guía" : "Explore the guide"}
          <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
        </span>
      </div>
    </Link>
  );
}